import WebviewComponentAdaptor from "@shared/components/application/other/WebviewComponentAdaptor/WebviewComponentAdaptor.web";
import { postMessageToReactNativeWebView } from "@shared/utils/webview";
import Button from "@ui-kit/form/Button/Button.web";
import { useTranslation } from "@shared/utils/internationalization";

/**
 * A button component that allows users to return to the explore/home screen.
 * This component is only rendered in React Native webview environments.
 *
 * When clicked, it sends a "RETURN_TO_EXPLORE" message to the React Native app
 * to handle navigation back to the home screen.
 *
 * @example
 * ```tsx
 * <ReturnToExploreButton />
 * ```
 *
 * @returns A button component that triggers navigation back to the explore screen, or null in web environments
 */
export default function ReturnToExploreButton(): JSX.Element | null {
  const { t } = useTranslation("checkout");

  const postExploreMessage = () =>
    postMessageToReactNativeWebView({
      action: "RETURN_TO_EXPLORE",
    });

  return (
    <WebviewComponentAdaptor
      webComponent={null}
      webviewComponent={
        <Button.Solid
          as="span"
          width="100%"
          data-testid="order-status-return-to-explore"
          fontWeight={500}
          onClick={postExploreMessage}
        >
          {t("Return to explore")}
        </Button.Solid>
      }
    />
  );
}
